export const DialogStyle = {
  dialogTitle: {
    sx: {
      backgroundColor: 'primary.main',
      color: 'white',
    },
    style: {
      display: 'flex',
    },
  },
  close: {
    marginLeft: 'auto',
    cursor: 'pointer',
  },
};
